export default __webpack_public_path__ + "static/media/modal-texture.df3aff18.png";